import React from 'react';
import dayjs from 'dayjs';

import Text from '~components/atoms/Text';

import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum, GoldTypeEnum, TransactionStatusEnum } from '~utils/enums';

import ReceiptPDF from './ReceiptPDF';
import * as ReceiptStyles from './_customerCollateralDetails.module.scss';

const CustomerCollateralDetails = () => {
    const allCustomerCollateral = useAppSelector(state => state.customer.customerCollateral.data);
    const customerDetails = useAppSelector((state) => state.customer.customerDetails);
    const selectedCollateralId = useAppSelector((state) => state.customer.tempCollateralState.collateralId);

    const inventoryList = useAppSelector((state) => state.gold.allInventories);

    const selectedCustomerCollateral = allCustomerCollateral.find((collateral) => collateral.collateralId === selectedCollateralId);

    if (!selectedCustomerCollateral) return;

    const getRegisterCategory = () => {
        const product = inventoryList.find((inventory) => inventory.productId === selectedCustomerCollateral.productId);

        if (!product) return '-';

        return `${FundTypeEnum[product?.fundType]} | ${GoldTypeEnum[product.goldType]}`;
    };

    const summaryTable = [
        {
            label: 'Collateral Status',
            value: TransactionStatusEnum[selectedCustomerCollateral.status],
        },
        {
            label: 'Collateral Date',
            value: dayjs(new Date()).format('DD/MM/YYYY hh:mm A'),
        },
        {
            label: 'Collateral End Date',
            value: selectedCustomerCollateral.collateralEndDate ? dayjs(selectedCustomerCollateral.collateralEndDate).format('DD/MM/YYYY hh:mm A') : '-',
        },
        // {
        //     label: 'Project Name',
        //     value: buyOrSellGoldParams.projectName ? buyOrSellGoldParams.projectName : '-',
        // },
        {
            label: 'Region Name',
            value: customerDetails.regionName,
        },
        {
            label: 'Branch Name',
            value: customerDetails.branchName,
        },
        {
            label: 'Branch Code',
            value: customerDetails.branchCode,
        },
        {
            label: 'Register Category',
            value: getRegisterCategory(),
        },
        {
            label: 'Name of Customer/Company Firm/Association',
            value: customerDetails.name,
        },
        {
            label: 'Identification No.',
            value: customerDetails.idNo,
        },
        {
            label: 'CIF No.',
            value: customerDetails.CIFNo,
        },
        {
            label: 'Price per gram (MYR)',
            value: selectedCustomerCollateral.paramGoldPrice === null ? `RM${(Math.round(Number(selectedCustomerCollateral.baseAPIPrice) * 100) / 100).toFixed(2)}` : `RM${(Math.round(Number(selectedCustomerCollateral.paramGoldPrice) * 100) / 100).toFixed(2)}`,
        },
        {
            label: 'Quantity',
            value: selectedCustomerCollateral.amount,
        },
        {
            label: 'Total Amount (MYR)',
            value: `RM${(Math.round(Number(selectedCustomerCollateral.marketValue) * 100) / 100).toFixed(2)}`,
        },
    ];

    const productTableHeader = ['Gold Product', 'Price per gram (MYR)'];
    const productTableData = [selectedCustomerCollateral.productName, (selectedCustomerCollateral.paramGoldPrice === null ? `RM${(Math.round(Number(selectedCustomerCollateral.baseAPIPrice) * 100) / 100).toFixed(2)}` : `RM${(Math.round(Number(selectedCustomerCollateral.paramGoldPrice) * 100) / 100).toFixed(2)}`)];

    return (
        <div className={ReceiptStyles.container}>
            <table className={ReceiptStyles['details-table']}>
                <tbody>
                    {summaryTable.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item.label}</td>
                                <td>{item.label === 'Serial No.' ? item.value : `: ${item.value}`}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <div className={ReceiptStyles['product-container']}>
                <Text
                    label='Gold Description'
                    isBold
                />

                <table>
                    <tbody>
                        <tr>
                            {productTableHeader.map((item, index) => (
                                <td key={index}>
                                    {item}
                                </td>
                            ))}
                        </tr>

                        <tr>
                            {productTableData.map((item, index) => (
                                <td key={index}>
                                    {item}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className={ReceiptStyles['button-container']}>
                <ReceiptPDF
                    collateralDetails={selectedCustomerCollateral}
                    customerDetails={customerDetails}
                />
            </div>
        </div>
    );
};

export default CustomerCollateralDetails;
